import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pending-section mb-6"
}
const _hoisted_2 = { class: "font-weight-bold" }
const _hoisted_3 = { class: "text-caption text-grey" }
const _hoisted_4 = { class: "d-flex ga-2" }

interface User {
  id: string
  username?: string
  first_name?: string
  last_name?: string
  email: string
  status: string
}

interface Props {
  pendingUsers: User[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PendingUsersCard',
  props: {
    pendingUsers: {}
  },
  emits: ['approve', 'reject'],
  setup(__props: any) {

/* eslint-disable no-undef */






return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (__props.pendingUsers.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-h6 mb-3" }, "� Pending User Approvals", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pendingUsers, (user) => {
          return (_openBlock(), _createBlock(_component_v_card, {
            key: user.id,
            class: "mb-2",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "d-flex justify-space-between align-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(user.username), 1),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(user.email), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_btn, {
                      color: "success",
                      size: "small",
                      onClick: ($event: any) => (_ctx.$emit('approve', user))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-check", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[1] || (_cache[1] = _createTextVNode(" Approve ", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      size: "small",
                      variant: "outlined",
                      onClick: ($event: any) => (_ctx.$emit('reject', user))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[3] || (_cache[3] = _createTextVNode(" Reject ", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_v_divider, { class: "my-6" })
      ]))
    : _createCommentVNode("", true)
}
}

})